import { getData } from "../../utils/reusables";
import {
  iTypeCategory,
  typeApiResponse,
  categoryContextType,
  categoryDataTypes,
} from "../../utils/typeDefs";
import { apiUrls } from "../../utils/apiUrls";
import { useState, useEffect, createContext } from "react";
import { AxiosResponse } from "axios";

type categoryContextProps = {
  children?: JSX.Element;
};

const CategoryContext = createContext<categoryContextType | null>(null);

const CategoryContextProvider = ({ children }: categoryContextProps) => {
  const [categoryData, setCategoryData] = useState<iTypeCategory[] | []>([]);

  useEffect(() => {
    getData(apiUrls.category.base).then(
      (result: AxiosResponse<categoryDataTypes & typeApiResponse>) => {
        setCategoryData([result.data.data]);
      }
    );
  }, []);

  return (
    <CategoryContext.Provider
      value={{
        categoryData,
        setCategoryData,
      }}
    >
      {children}
    </CategoryContext.Provider>
  );
};

export { CategoryContextProvider, CategoryContext };
